import { requestApi } from '../util/network'
// 获取推荐人
export const getInviterInfo =
    (inviter_id) =>
      requestApi(
        '/Login/get_inviter',
        'POST',
        {
          'inviter_id': inviter_id
        }
      )
// 用户注册
export const register =
    (username, password, passwordConfirm, inviterId,pictureCode='') =>
      requestApi(
        '/Login/register',
        'POST',
        {
          'username': username,
          'password': password,
          'password_confirm': passwordConfirm,
          'inviter_id': inviterId,
            'captcha':pictureCode,
          'client': 'wap'
        }
      )
// 用户手机注册
export const registerByMobile =
    (member_company, member_truename, member_email,area_code,telphone,captcha_normal,country, member_password, member_password_confirm, inviterId) =>
      requestApi(
        '/Connect/register',
        'POST',
        {
          'member_company':member_company,	
          'member_truename':member_truename,
          'member_email':member_email,
          'area_code': area_code,
          'telphone':telphone,
          'captcha_normal':captcha_normal,
          'country':country,
          'member_password': member_password,
          'member_password_confirm': member_password_confirm,
          'inviter_id': inviterId,
          'client': 'wap'
        }
      )
